export const formatColors = colors => {
  return colors.join(', ');
};
